import { useEffect, useRef, useState } from "react"

const ACTIVITY_EVENTS = ["mousemove", "keydown", "mousedown", "touchstart"] as const

const INACTIVITY_TIMEOUT = 5 * 1000

export function useUserActivity(): { isActive: boolean } {
  const [isActive, setIsActive] = useState(true)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    const handleActivity = () => {
      setIsActive(true)
      if (timer.current) clearTimeout(timer.current)
      timer.current = setTimeout(() => setIsActive(false), INACTIVITY_TIMEOUT)
    }

    ACTIVITY_EVENTS.forEach((event) => window.addEventListener(event, handleActivity))

    timer.current = setTimeout(() => {
      setIsActive(false)
    }, INACTIVITY_TIMEOUT)

    return () => {
      if (timer.current) clearTimeout(timer.current)
      ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, handleActivity))
    }
  }, [])

  return { isActive }
}
